/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { ILPDirectorRequest } from '../models';
import { ILPDirectorViewIEnumerableResponse } from '../models';
import { IndividualFirmViewIEnumerableResponse } from '../models';
import { IndividualViewIEnumerableResponse } from '../models';
import { LawIdUserLsApiViewIEnumerableResponse } from '../models';
import { PeopleStatsViewResponse } from '../models';
import { SearchLawIdUsersRequest } from '../models';
import { SignatoryFilterRequest } from '../models';
import { SignatoryRequest } from '../models';
import { SignatoryViewIEnumerableResponse } from '../models';
/**
 * PeopleApi - axios parameter creator
 * @export
 */
export const PeopleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetILPDirectorsByPracticeIdPracticeIdGet: async (practiceId: number, keyword?: string, showActiveOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1PeopleGetILPDirectorsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v1/People/GetILPDirectorsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (showActiveOnly !== undefined) {
                localVarQueryParameter['showActiveOnly'] = showActiveOnly;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetIndividualsByPracticeIdPracticeIdGet: async (practiceId: number, keyword?: string, showActiveOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1PeopleGetIndividualsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v1/People/GetIndividualsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (showActiveOnly !== undefined) {
                localVarQueryParameter['showActiveOnly'] = showActiveOnly;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetPeopleStatsByPracticeIdPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1PeopleGetPeopleStatsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v1/People/GetPeopleStatsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetPrincipalsByPracticeIdPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1PeopleGetPrincipalsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v1/People/GetPrincipalsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetPrincipalsByPracticeStatusPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1PeopleGetPrincipalsByPracticeStatusPracticeIdGet.');
            }
            const localVarPath = `/api/v1/People/GetPrincipalsByPracticeStatus/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchLawIdUsersRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetSearchLawIdUsersPost: async (body?: SearchLawIdUsersRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/People/GetSearchLawIdUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetSignatoriesByPracticeIdPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1PeopleGetSignatoriesByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v1/People/GetSignatoriesByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SignatoryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetSignatoriesPost: async (body?: SignatoryFilterRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/People/GetSignatories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetTrustContactsPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1PeopleGetTrustContactsPracticeIdGet.');
            }
            const localVarPath = `/api/v1/People/GetTrustContacts/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetTrustCoordinatorsPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1PeopleGetTrustCoordinatorsPracticeIdGet.');
            }
            const localVarPath = `/api/v1/People/GetTrustCoordinators/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ILPDirectorRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleSaveIlpDirectorPost: async (body?: ILPDirectorRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/People/SaveIlpDirector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleSaveSignatoryPost: async (body?: SignatoryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/People/SaveSignatory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PeopleApi - functional programming interface
 * @export
 */
export const PeopleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ILPDirectorViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV1PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualFirmViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV1PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PeopleStatsViewResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV1PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PeopleGetPrincipalsByPracticeIdPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualFirmViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV1PeopleGetPrincipalsByPracticeIdPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PeopleGetPrincipalsByPracticeStatusPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualFirmViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV1PeopleGetPrincipalsByPracticeStatusPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SearchLawIdUsersRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PeopleGetSearchLawIdUsersPost(body?: SearchLawIdUsersRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LawIdUserLsApiViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV1PeopleGetSearchLawIdUsersPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PeopleGetSignatoriesByPracticeIdPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatoryViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV1PeopleGetSignatoriesByPracticeIdPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SignatoryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PeopleGetSignatoriesPost(body?: SignatoryFilterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatoryViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV1PeopleGetSignatoriesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PeopleGetTrustContactsPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV1PeopleGetTrustContactsPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PeopleGetTrustCoordinatorsPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV1PeopleGetTrustCoordinatorsPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {ILPDirectorRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PeopleSaveIlpDirectorPost(body?: ILPDirectorRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV1PeopleSaveIlpDirectorPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PeopleSaveSignatoryPost(body?: SignatoryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV1PeopleSaveSignatoryPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PeopleApi - factory interface
 * @export
 */
export const PeopleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any): AxiosPromise<ILPDirectorViewIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV1PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any): AxiosPromise<IndividualFirmViewIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV1PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId: number, options?: any): AxiosPromise<PeopleStatsViewResponse> {
            return PeopleApiFp(configuration).apiV1PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetPrincipalsByPracticeIdPracticeIdGet(practiceId: number, options?: any): AxiosPromise<IndividualFirmViewIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV1PeopleGetPrincipalsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetPrincipalsByPracticeStatusPracticeIdGet(practiceId: number, options?: any): AxiosPromise<IndividualFirmViewIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV1PeopleGetPrincipalsByPracticeStatusPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchLawIdUsersRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetSearchLawIdUsersPost(body?: SearchLawIdUsersRequest, options?: any): AxiosPromise<LawIdUserLsApiViewIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV1PeopleGetSearchLawIdUsersPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetSignatoriesByPracticeIdPracticeIdGet(practiceId: number, options?: any): AxiosPromise<SignatoryViewIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV1PeopleGetSignatoriesByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatoryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetSignatoriesPost(body?: SignatoryFilterRequest, options?: any): AxiosPromise<SignatoryViewIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV1PeopleGetSignatoriesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetTrustContactsPracticeIdGet(practiceId: number, options?: any): AxiosPromise<IndividualViewIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV1PeopleGetTrustContactsPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleGetTrustCoordinatorsPracticeIdGet(practiceId: number, options?: any): AxiosPromise<IndividualViewIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV1PeopleGetTrustCoordinatorsPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ILPDirectorRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleSaveIlpDirectorPost(body?: ILPDirectorRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PeopleApiFp(configuration).apiV1PeopleSaveIlpDirectorPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PeopleSaveSignatoryPost(body?: SignatoryRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PeopleApiFp(configuration).apiV1PeopleSaveSignatoryPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PeopleApi - object-oriented interface
 * @export
 * @class PeopleApi
 * @extends {BaseAPI}
 */
export class PeopleApi extends BaseAPI {
    /**
     * 
     * @param {number} practiceId 
     * @param {string} [keyword] 
     * @param {boolean} [showActiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV1PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any) {
        return PeopleApiFp(this.configuration).apiV1PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} practiceId 
     * @param {string} [keyword] 
     * @param {boolean} [showActiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV1PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any) {
        return PeopleApiFp(this.configuration).apiV1PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV1PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV1PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV1PeopleGetPrincipalsByPracticeIdPracticeIdGet(practiceId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV1PeopleGetPrincipalsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV1PeopleGetPrincipalsByPracticeStatusPracticeIdGet(practiceId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV1PeopleGetPrincipalsByPracticeStatusPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {SearchLawIdUsersRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV1PeopleGetSearchLawIdUsersPost(body?: SearchLawIdUsersRequest, options?: any) {
        return PeopleApiFp(this.configuration).apiV1PeopleGetSearchLawIdUsersPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV1PeopleGetSignatoriesByPracticeIdPracticeIdGet(practiceId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV1PeopleGetSignatoriesByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {SignatoryFilterRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV1PeopleGetSignatoriesPost(body?: SignatoryFilterRequest, options?: any) {
        return PeopleApiFp(this.configuration).apiV1PeopleGetSignatoriesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV1PeopleGetTrustContactsPracticeIdGet(practiceId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV1PeopleGetTrustContactsPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV1PeopleGetTrustCoordinatorsPracticeIdGet(practiceId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV1PeopleGetTrustCoordinatorsPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {ILPDirectorRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV1PeopleSaveIlpDirectorPost(body?: ILPDirectorRequest, options?: any) {
        return PeopleApiFp(this.configuration).apiV1PeopleSaveIlpDirectorPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {SignatoryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV1PeopleSaveSignatoryPost(body?: SignatoryRequest, options?: any) {
        return PeopleApiFp(this.configuration).apiV1PeopleSaveSignatoryPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
